export default {
    drug: state => state.drug,
    drugsSummary: state => state.drugsSummary,
    summaryTemp: state => state.summaryTemp,
    productsSummary: state => state.productsSummary,
    dose: state => state.dose,
    drugTab: state => state.drugTab,
    product: state => state.product,
    veterinaryProductsMap: state => state.veterinaryProductsMap,
    humanProductsMap: state => state.humanProductsMap,
    dose_index: state => state.dose_index,
    reference: state => state.reference,
    showProducts: state => state.showProducts,
    getVirtualScroll: state => state.virtualScroll,
    searchValue: state => state.searchValue,
    classes: state => state.classes,
    category: state => state.category,
    itemsList: state => state.itemsList,
    hasFilter: state => state.hasFilter,
    dogFilter: state => state.dogFilter,
    catFilter: state => state.catFilter,
    presentationList: state => state.presentationList,
    presentationFilter: state => state.presentationFilter,
    classesList: state => state.classesList,

    classesFilter: state => state.classesFilter,
    categoryFilter: state => state.categoryFilter,
    systemFilter: state => state.systemFilter,


    brandList: state => state.brandList,
    brandFilter: state => state.brandFilter,
    activePrinciplesList: state => state.activePrinciplesList,
    activePrinciplesFilter: state => state.activePrinciplesFilter,

    petAges: state => state.petAges,
    petAgesFilter: state => state.petAgesFilter,

    petSizes: state => state.petSizes,
    petSizesFilter: state => state.petSizesFilter,

    petBreeds: state => state.petBreeds,
    petBreedsFilter: state => state.petBreedsFilter,

    features: state => state.features,
    featuresFilter: state => state.featuresFilter,

    brandLines: state => state.brandLines,
    brandLinesFilter: state => state.brandLinesFilter,
    lines: state => state.lines,

};